// @flow
import * as React from 'react';
import { Stack, Typography } from '@mui/material';
import { withButton } from '../../../../../features';
import { ChannelAttributionEditButton } from './channel-attribution-form';
import { useClient } from '../../../hooks/client-context';
import { Record } from '../../../../../shared';

type Props = {

};
const Attribution = (props: Props) => {
  const client = useClient();

  return (
    <Stack gap={1} flex={1}>
      <Typography variant={'subtitle1'} flex={1}>Channel attribution</Typography>
      <Record title={'Source'} value={client.utmSource || '-'} />
      <Record title={'Campaign'} value={client.utmCampaign || '-'} />
    </Stack>
  );
};

export const ChannelAttribution = withButton(
  Attribution,
  ChannelAttributionEditButton
)
